import axiosInstance from "../../interceptor/intercetptor-inctence";
import {
	mockCollectPatientInvoicePayment,
	mockGetPatientInvoiceDetails,
	mockGetPatientInvoices,
} from "./data/mockPatientAccountsService";

// Set to false when invoice APIs are ready on backend
const USE_MOCK_DATA = true;

export const getPatientInvoicesAPI = (data) => {
	// if (USE_MOCK_DATA) return mockGetPatientInvoices(data);
	return axiosInstance.post(`/pharma/patientInvoicesList`, data);
};

export const getPatientInvoiceDetailsAPI = (data) => {
	if (USE_MOCK_DATA) return mockGetPatientInvoiceDetails(data);
	return axiosInstance.post(`pharma/view-patient-invoice`, data);
};

export const payRemainingSalesAPI = (data) => {
	return axiosInstance.post(`pharma/pay-remaining-sales`, data);
};

export const collectPatientInvoicePaymentAPI = (data) => {
	if (USE_MOCK_DATA) return mockCollectPatientInvoicePayment(data);
	return axiosInstance.post(`pharma/collect-patient-invoice-payment`, data);
};
